// extracted by mini-css-extract-plugin
export default {"pageTitle":"SupportPage_pageTitle__29BZ6","supportMessenger":"SupportPage_supportMessenger__RwWr2"};